<div class="detail-container">
  <nb-card>
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>Protokolltyp</h5>
      <wr-edit-delete-button-group *ngIf="canEdit() && !isNew()"
                                   (edit)="onEdit()"
                                   (delete)="onDelete()">
      </wr-edit-delete-button-group>
    </nb-card-header>
    <nb-card-body>
      <nb-tabset class="vertical-tabset" (changeTab)="onTabChange($event)">
        <nb-tab tabTitle="Stammdaten">
          <wr-protocol-type-form></wr-protocol-type-form>
        </nb-tab>
        <nb-tab tabTitle="Einstellungen" *ngIf="!isNew()">
          <wr-protocol-type-settings></wr-protocol-type-settings>
        </nb-tab>
        <nb-tab tabTitle="Feldgruppen" *ngIf="!isNew()">
          <wr-protocol-type-collections></wr-protocol-type-collections>
        </nb-tab>
      </nb-tabset>
    </nb-card-body>
    <nb-card-footer *ngIf="canEdit()">
      <button size="medium" [disabled]="!isEditing()" nbButton status="primary" (click)="submit()">Speichern</button>
      <button size="medium" [disabled]="!isEditing()" nbButton status="basic" (click)="cancel()">Abbrechen</button>
    </nb-card-footer>
  </nb-card>
</div>
